import * as THREE from "three";

type Elbow = { lower: THREE.Bone; helper: THREE.Bone; rest: THREE.Quaternion; inverse: THREE.Quaternion };
const cache = new WeakMap<THREE.Skeleton, Elbow[]>();
const delta = new THREE.Quaternion(), half = new THREE.Quaternion(), twist = new THREE.Quaternion();
export function resetBodyDeformers(skeleton: THREE.Skeleton): void { cache.delete(skeleton); }
/** Keep the posterior elbow patch on the bend bisector after animation and IK. */
export function applyBodyDeformers(skeleton: THREE.Skeleton): void {
  let elbows = cache.get(skeleton);
  if (!elbows) {
    elbows = [];
    for (const side of ["l", "r"]) {
      const helper = skeleton.bones.find(b => b.name === "elbow_deform_" + side);
      const lower = skeleton.bones.find(b => b.name === "lowerarm_" + side);
      if (!helper || !lower) continue;
      const parent = skeleton.bones.indexOf(lower.parent as THREE.Bone);
      const local = skeleton.boneInverses[parent].clone()
        .multiply(skeleton.boneInverses[skeleton.bones.indexOf(lower)].clone().invert());
      const rest = new THREE.Quaternion().setFromRotationMatrix(local);
      elbows.push({lower, helper, rest, inverse: rest.clone().invert()});
    }
    cache.set(skeleton, elbows);
  }
  for (const {lower, helper, rest, inverse} of elbows) {
    delta.copy(inverse).multiply(lower.quaternion).normalize();
    // Forearm pronation belongs along the forearm. It must not rotate the
    // elbow hinge ring halfway around its axis as though the joint were a ball.
    twist.set(delta.x, 0, 0, delta.w);
    if (twist.lengthSq() > 1e-10) delta.multiply(twist.normalize().invert());
    half.identity().slerp(delta, .5);
    helper.quaternion.copy(rest).multiply(half);
  }
}
